import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { getProductList } from "../../redux/reducer/product.reducer";

import ShopHero from "./components/shop.hero";
import ShopProduct from "./components/shop.product";
import CommonCategory from "../../components/common/common.category";
import { useLocation } from "react-router-dom";
import scrollToTop from "../../helpers/scroll.to.top";

export default function Shop() {
  const dispatch = useDispatch();
  const { hash, pathname } = useLocation();
  const [isInitial, setIsInitial] = useState(false);

  useEffect(() => {
    setIsInitial(true);
    dispatch(getProductList());
  }, []);

  useEffect(() => {
    if (isInitial && hash) {
      const element = document.getElementById(hash.replace("#", ""));

      if (element) {
        const offset = 150;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    } else {
      scrollToTop();
    }
  }, [hash, pathname]);

  return (
    <article className="shop">
      <ShopHero />
      <CommonCategory className="--shop" />
      <ShopProduct />
    </article>
  );
}
